import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'MoodAngryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-angry",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 9l2 1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 9l-2 1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14.5 16.05a3.5 3.5 0 0 0 -5 0"
    }, null), _createTextVNode(" ")]);
  }
};